import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import axios from "axios";

import Home from "./pages/Home";
import Login from "./pages/Login";
import Settings from "./pages/Settings";
import Help from "./pages/Help";
import Events from "./pages/Events";
import CreateEvent from "./pages/CreateEvent";
import Logs from "./pages/Logs";
import { rolesConfig, hasRequiredRole } from "./rolesConfig";
//import StaffStats from "./pages/StaffStats";

import Sidenav from "./Sidenav";

import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import darkTheme from "./theme";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

// 1) Create the Axios interceptor *above* your component definition so it only sets up once
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("discord_jwt");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // A) Check if there's a token in the URL (e.g., ?token=...)
    const params = new URLSearchParams(location.search);
    const tokenFromURL = params.get("token");
    if (tokenFromURL) {
      localStorage.setItem("discord_jwt", tokenFromURL);
      window.history.replaceState({}, "", location.pathname); // remove "?token=..."
    }

    // B) Attempt to fetch user info if we have a token
    const storedToken = localStorage.getItem("discord_jwt");
    if (storedToken) {
      axios
        .get(`${process.env.REACT_APP_API_URL}/api/auth/session`)
        .then((response) => {
          if (response.data.user) {
            setUser(response.data.user);
          }
        })
        .catch((error) => {
          console.error("Failed to get user with token:", error);
          localStorage.removeItem("discord_jwt"); // Clean up if invalid
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [location]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Routes>
        <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
        <Route
          path="/home"
          element={
            user ? (
              <Sidenav user={user} setUser={setUser}>
                <Home />
              </Sidenav>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/"
          element={
            user ? (
              <Sidenav user={user} setUser={setUser}>
                <Home />
              </Sidenav>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/settings"
          element={
            user ? (
              <Sidenav user={user} setUser={setUser}>
                <Settings />
              </Sidenav>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/help"
          element={
            user ? (
              <Sidenav user={user} setUser={setUser}>
                <Help />
              </Sidenav>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/events"
          element={
            user && hasRequiredRole(user, rolesConfig.eventsPage) ? (
              <Sidenav user={user} setUser={setUser}>
                <Events user={user} />
              </Sidenav>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        {/* <Route
          path="/staff-stats"
          element={
            user && user.isAdmin ? (
              <Sidenav user={user} setUser={setUser}>
                <StaffStats user={user} />
              </Sidenav>
            ) : (
              <Navigate to="/login" />
            )
          }
        /> */}
        <Route
          path="/create-event"
          element={
            user && hasRequiredRole(user, rolesConfig.eventsPage) ? (
              <Sidenav user={user} setUser={setUser}>
                <CreateEvent user={user} />
              </Sidenav>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/logs"
          element={
            user && hasRequiredRole(user, rolesConfig.logsPage) ? (
              <Sidenav user={user} setUser={setUser}>
                <Logs user={user} />
              </Sidenav>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
